import MojitoCore from 'mojito/core';
import { STORE_KEY, initialState } from './slice.js';

const reduxInstance = MojitoCore.Services.redux;

/**
 * BettingCenter related selectors.
 *
 * @module BettingCenterSelectors
 * @name selectors
 * @memberof Mojito.Modules.BettingCenter
 */

/**
 * Selects betting center store state.
 *
 * @function selectState
 *
 * @param {object} [state] - Application state object. If not provided then state from global {@link Mojito.Core.Services.redux|redux store} will be returned.
 * @returns {Mojito.Modules.BettingCenter.BettingCenterState} BettingCenter store state.
 * @memberof Mojito.Modules.BettingCenter.selectors
 */
export const selectState = state => {
    // Should be no need to fallback to global state once fully migrated to Redux.
    const appState = state || reduxInstance.store?.getState();
    return appState?.[STORE_KEY] || initialState;
};

/**
 * Selects current active tab.
 *
 * @function selectActiveTab
 *
 * @param {object} [state] - Application state object. If not provided then state from global {@link Mojito.Core.Services.redux|redux store} will be returned.
 * @returns {Mojito.Modules.BettingCenter.viewTypes} Current active tab.
 * @memberof Mojito.Modules.BettingCenter.selectors
 */
export const selectActiveTab = state => selectState(state).selectedTab;
